module.exports = __webpack_public_path__ + "static/prairie-meats-logo-2f5ee99211188d3ed6ae100db0fb4b08.jpeg";